var DatePreset;
(function (DatePreset) {
    DatePreset["LAST_SEVEN_DAYS"] = "lastSevenDays";
    DatePreset["LAST_THIRTY_DAYS"] = "lastThirtyDays";
    DatePreset["LAST_THREE_MONTHS"] = "lastThreeMonths";
    DatePreset["LAST_TWELVE_MONTHS"] = "lastTwelveMonths";
    DatePreset["ALL_TIME"] = "allTime";
    DatePreset["END_OF_WEEK"] = "endOfWeek";
    DatePreset["END_OF_MONTH"] = "endOfMonth";
    DatePreset["END_OF_QUARTER"] = "endOfQuarter";
    DatePreset["CUSTOM"] = "custom";
})(DatePreset || (DatePreset = {}));
export default DatePreset;
